import { catchError, combineLatest, map, Observable, of } from 'rxjs';

import { FinnairLocation } from '@fcom/dapi/api/models';
import { isPresent } from '@fcom/core/utils';
import { Location } from '@fcom/core-api';

import { TripType } from '../interfaces';

/**
 * List of short haul country codes
 * Taken from ancillaries microservice
 */
const shortHaulCountries: string[] = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SK',
  'IL',
  'HR',
  'TR',
  'SI',
  'MT',
  'EE',
  'RU',
  'IS',
  'EG',
  'AL',
];

export const isShortHaulCountry = (countryCode: string): boolean =>
  shortHaulCountries.some((country) => country === countryCode?.toUpperCase());

export const isShortHaulFlight = (
  departureLocation: FinnairLocation | Location,
  arrivalLocation: FinnairLocation | Location
): boolean => {
  if (!isPresent(departureLocation) || !isPresent(arrivalLocation)) {
    return true;
  }
  return isShortHaulCountry(departureLocation.countryCode) && isShortHaulCountry(arrivalLocation.countryCode);
};

export const resolveTripTypeByHaul = (
  locationService: { bestGuessFor: (query: string, locale: string) => Observable<Location> },
  origin: string,
  destination: string,
  locale: string,
  fallback: TripType = TripType.ONEWAY
): Observable<TripType> => {
  if (!origin || !destination) {
    return of(fallback);
  }
  return combineLatest([
    locationService.bestGuessFor(origin, locale),
    locationService.bestGuessFor(destination, locale),
  ]).pipe(
    map(([originLocation, destinationLocation]) =>
      isShortHaulFlight(originLocation, destinationLocation) ? TripType.ONEWAY : TripType.RETURN
    ),
    catchError(() => of(fallback))
  );
};
